import { forwardRef } from 'react';

type Props = React.SVGAttributes<SVGSVGElement>;
type Ref = SVGSVGElement;

const CopyRounded = forwardRef<Ref, Props>((props, ref) => (
    <svg
        width='18'
        height='21'
        viewBox='0 0 18 21'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
        ref={ref}
    >
        <path
            d='M12 5.5V3C12 1.89543 11.1046 1 10 1H3C1.89543 1 1 1.89543 1 3V15C1 16.1046 1.89543 17 3 17H7.5'
            stroke='#23B3E5'
        />
        <rect x='7.5' y='5.5' width='10' height='15' rx='1.5' stroke='#23B3E5' />
    </svg>
));

export default CopyRounded;
